export default {
  title: 'Onboarding-link aanmaken',
  steps: {
    select_gateway: 'Gateway selecteren',
    copy_link: 'Link kopiëren',
  },
  select_gateway: {
    description: 'Kies de betaalgateway waarvoor u een langdurige onboarding-link wilt genereren.',
  },
  link: {
    proxy_url_label: 'Onboarding-URL',
    expires_label: 'Vervalt',
    copy_button: 'URL kopiëren',
    copied: 'Gekopieerd!',
    description:
      'Deel deze URL met de merchant. Deze verwijst naar de gateway-onboardingpagina en is geldig tot de vervaldatum.',
  },
  buttons: {
    next: 'Volgende',
    back: 'Terug',
    done: 'Gereed',
  },
  toasts: {
    create_success: 'Onboarding-link succesvol aangemaakt.',
    create_failed: 'Onboarding-link aanmaken mislukt.',
  },
};
